import React, { useState } from "react";
import { BiPlay } from "react-icons/bi";
import { IoChatbubblesSharp } from "react-icons/io5";
import { MdDeliveryDining } from "react-icons/md";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import image from "../home page/hero images/pngegg.png";
import line from "../home page/hero images/line.png";
import howtobuy from "../svg x gifs/Black Screen 10 seconds-360p.mp4";
function Hero() {
  // another way to do scrolling (bellow)
  // function scrollToTestDiv() {
  //   const divElement = document.getElementById("get-started");
  //   divElement.scrollIntoView({ behavior: "smooth" });
  // }
  const [video, setvideo] = useState(false);
  function scrollToTestDiv() {
    window.scroll({
      top: 810,
      left: 0,
      behavior: "smooth",
    });
  }

  return (
    <div className="pt-20 phonex2:pt-0">
      <>
        {video && (
          <div
            onClick={() => setvideo(false)}
            className="fixed z-[10000000] inset-0 bg-gray-900 bg-opacity-50  overflow-y-hidden flex justify-center items-center "
          />
        )}
        <video
          className={`${
            video
              ? "z-[10000000] scale-100 opacity-100 duration-500 h-[80%] w-[80%] object-cover absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
              : "z-[10000000] scale-50 pointer-events-none opacity-0 duration-500 h-[80%] w-[80%] object-cover absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          }`}
          autoPlay
          loop
          controls
          id="full-screenVideo"
        >
          <source src={howtobuy} type="video/mp4" />
        </video>
      </>

      <div className="absolute top-[130px] left-[120px]">
        <span className="flex h-3 w-3 relative ">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-primary-100"></span>
        </span>
      </div>
      <div className="absolute top-[150px] right-[650px]">
        <span className="flex h-6 w-6 relative ">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-6 w-6 bg-primary-100"></span>
        </span>
      </div>
      <div className="absolute top-[450px] right-[1000px]">
        <span className="flex h-4 w-4 relative ">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-primary-100"></span>
        </span>
      </div>
      <div className="absolute top-[680px] right-[1600px]">
        <span className="flex h-4 w-4 relative ">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-primary-100"></span>
        </span>
      </div>
      <div className="absolute top-[650px] demitablet:top-[500px] right-[100px]">
        <span className="flex h-4 w-4 relative ">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-primary-100"></span>
        </span>
      </div>
      <div className="flex  demitablet:text-center demitablet:justify-center demitablet:items-center demitablet:flex-col relative capitalize">
        <div className="mb-[120px] phonex2:mt-[190px]  mt-[120px] demitablet:mt-[70px] demitablet:mb-[350px] max-w-[498px]">
          <h1 className="main-titles font-font1 font-bold leading-tight">
            Summer Fun with Citronella
          </h1>
          <p className="my-4  demitablet:max-w-full  max-w-[400px] tablet:text-[15px] font-font text-gray-700">
            Receive a free 15 mL bottle of Citronella when you place a 125 PV or
            more loyalty order by April 15 while supplies last!
          </p>
          <div className="my-10 demitablet:text-center demitablet:justify-center demitablet:items-center font-font1  flex">
            {" "}
            <button
              onClick={scrollToTestDiv}
              className="py-6 tablet:py-4 tablet:px-6 hover:bg-white hover:text-gray-900 border-2 border-gray-900/0 hover:border-gray-900 duration-700 px-10 font-font1 font-light rounded-md bg-gray-900 text-white"
            >
              Explore Now!
            </button>
            <button
              onClick={() => setvideo(true)}
              className="flex ml-10 items-center"
            >
              <span className="flex h-12 w-12 relative ">
                <BiPlay className="absolute pl-1 w-8 h-8 text-white z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75">
                  {" "}
                </span>

                <span className="relative inline-flex rounded-full h-12 w-12 bg-primary-100"></span>
              </span>
              <span className="mx-4 text-primary-100">How To Order?</span>
            </button>
          </div>
          <div className="pt-16 phone:hidden demitablet:absolute demitablet:left-0 demitablet:text-left demitablet:w-[500px] flex justify-center items-center">
            <IoChatbubblesSharp className="h-36 w-36 text-primary-100" />
            <h2 className="mx-10 tablet:text-[15px] font-font text-gray-700 capitalize">
              Cinnaman oils whether it is the leaf oil or the bark oil tends to
              be far superior terms of quality, aroma and purity.
            </h2>
          </div>
        </div>

        <div className="">
          <img
            className="absolute mdd:h-max phone:mt-[189px] phonex2:mt-[227px] mdd:mt-[281px]   phone:transform phone:-translate-x-1/2 phone:-translate-y-1/2 phone:top-1/2 phone:left1/2 top-[15%] tablet:top-[12%] demitablet:top-[55%] demitablet:h-[300px] h-[498px]  tablet:h-[400px]"
            src={image}
            alt="imag"
          />
          <div className=" text-gray-900 demitablet:top-[77%] phone:right-0 demitablet:right-64 demitablet:shadow-2xl border-[1px] border-white font-font2 absolute  right-10 tablet:right-0 top-[340px] tablet:top-[250px] backdrop-blur-md bg-primary-200/20 flex  w-[270px] h-[99px] tablet:h-[87px] rounded-md ">
            <div className="m-4">
              <MdDeliveryDining className=" bg-gray-900 tablet:w-14 tablet:h-14 w-16 h-16 p-2 text-primary-100 rounded-md" />
            </div>{" "}
            <div className=" flex absolute  right-16 top-4 space-x-2 text-gray-900 font-font2 justify-center items-start  ">
              <span className="flex h-3 w-3 mt-2 relative  ">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-200 opacity-75"></span>
                <span className="relative inline-flex  rounded-full h-3 w-3 bg-primary-100"></span>
              </span>
              <div className="">
                <div className="-mr-8 mt-[1px] flex flex-col">
                  <h1>12 Hours</h1>
                  <h1 className="text-[20px] ">Fast Delivery</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="get-started"></div>

      <div className="">
        <img
          className="absolute phone:top-[1030px] top-[840px] tablet:top-[770px] tablet:h-[250px]  -z-10 h-[410px] left-0"
          src={line}
          alt=""
        />
      </div>
      <div className="flex phone:justify-center bg-gray-900 text-white capitalize w-full phone:h-auto h-[250px] rounded-md mb-[70px]">
        <div className="flex phone:flex-col phonex2:px-4 px-24 demitablet:px-10 phone:justify-center phone:py-10 phone:text-center    justify-between items-center">
          <h1 className="main-mini-titles w-full">
            what does Edens Garden do to your face?
          </h1>
          <p className="text-md demitablet:text-[14px] max-w-[600px] font-font font-thin phone:px-10 phone:py-6 p-28 phonex2:p-4">
            Organic lavender essential oil is a middle note steam distilled from
            the flowers of Lavandula angustifolia. One of our most popular
            essential oils, lavender oil has an unmistakable sweet, floral and
            herbal aroma found in body care and perfumes.
          </p>
          <div>
            <div className="bg-primary-200 absolute rounded-full h-14 animate-ping w-14 demitablet:w-1 demitablet:h-1 z-0 p-10 demitablet:p-6 " />
            <div className="bg-primary-100 z-10 relative rounded-full h-10 w-10 p-10 demitablet:p-6 ">
              <MdOutlineHealthAndSafety className="w-10 h-10 absolute demitablet:p-1  transform -translate-x-1/2 -translate-y-1/2 top-1/2 left1/2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
